import { CHESS_SIDE } from "../constants";
export const playerName = (player) => {
    if (!player)
        return "";
    let s = player.first_name;
    const lastName = player.last_name;
    if (lastName && lastName.length) {
        s += " " + lastName[0];
    }
    if (s)
        return s;
    return player.display_name;
};
export const simplePlayer = (profile) => {
    if (!profile)
        return null;
    return {
        user_id: profile.user_id,
        username: profile.username,
        first_name: profile.first_name,
        last_name: profile.last_name,
        school: {
            school_name: profile.school ? profile.school.school_name : "",
        },
        name: playerName(profile),
        dna: profile.dna,
        role: profile.role,
    };
};
export const getPlayerColor = function (match, userId) {
    if (!match)
        return "";
    if (match.player1 && match.player1.user_id === userId) {
        return CHESS_SIDE.WHITE;
    }
    if (match.player2 && match.player2.user_id === userId) {
        return CHESS_SIDE.BLACK;
    }
    return "";
};
